<template>
<!-- 省市区 -->
    <div class="modal" :class="modalClass" v-show="showMask">
        <div class="modal-bg" @click="closeMask" v-if="iscloseMask"></div>
        <div class="modal-bg" v-else></div>
        <div class="modal-content" ref="monthPie" :style="widthStyle">
            <div class="modal-content2">
              <div class="modal-warp ac">
                  <slot name="mdBox"></slot>
              </div>
              <div class="modal-footer ac" v-if="modalFoot">
                  <div class="sig" v-if="type == 'alert'">
                      <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                  </div>
                  <div v-if="type != 'alert'">
                      <button class="btn btn-blue" @click="dangerBtn">{{btnText}}</button>
                      <button class="btn btn-none" id="closeModal" @click="closeMask">{{cancelText}}</button>
                  </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Dialog",
    props:{
        iscloseMask:{
          type:Boolean,
          default: false,
        },
        modalClass:{
            type:String,
            default:function(){
                return 'defModal';
            },
        },
        title:{
            type:String,
            default:function(){
                return '';
            },
        },
        width:{
            type:String,
            default:function(){
                return '90';
            },
        },
        type:{
            type:String,
            default:function(){
                return 'normal';
            },
        },
        modalFoot:{
            type:Boolean,
            default: true,
        },
        btnText:{
            type:String,
            default:function(){
                return 'YES';
            },
        },
        cancelText:{
            type:String,
            default:function(){
                return 'sure';
            },
        },
        callback:{
            type:Function
        }
    },
    data() {
        return {
            showMask: false,
            timer:'',
            loadText:'loading...',
            widthStyle:'',
            height:'',
        }
    },
    mounted() {
        // this.showMask = this.value;
        this.widthStyle = 'width:'+this.width+'%;margin-left:-'+this.width/2+'%';
    },
    created() {

    },
    methods: {
        //打开弹框
        showMaskFun () {
            let that = this;
            that.showMask = true;
        },
        closeMask(){
            // clearInterval(this.timer);
            this.showMask = false;
            this.height = '';
        },
        dangerBtn(){
            let that = this;
            // if(that.load == true){
            //     return;
            // }
            /*if(that.type === 'alert'){
                this.showMask = false;
                return;
            }*/
            let num = 0;
            this.callback();
            // setTimeout(() => {
            //     if(this.dialogShow == true){
            //         this.closeMask();
            //     }
            // }, 1);
        }
    }
}
</script>
<style lang="" scoped>
    .modal{position:fixed;top:0;left:0;width:100%;height:100%;z-index:999;}
    .modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
    .modal-content{position:absolute;top:50%;left:50%;transform:translate(0,-50%);background:none;border-radius:20px;padding:30px 0;min-height:330px;}
    .modal-content2{padding:0px;}
    .modal-warp{padding:20px 0;font-size:33px;color:#fff;}
    .modal-footer{padding:30px 0 20px;}
    .modal-footer .btn{box-shadow: none;font-size:30px;color: #fff;padding: 10px 10px;border-radius: 10px;width:47%;}
    .modal-footer .sig .btn{width: 45%;background-size: cover;height: 120px;text-transform: uppercase;}
</style>



// WEBPACK FOOTER //
// src/components/dialog.vue